import * as Yup from 'yup';

export const formInitialState = {
  name: '',
  exec_time: '',
  exec_seconds: '',
  last_exec_time: '',
  description: '',
  login: '',
  password: '',
  ipv4_address: '',
  port: '',
  active: false,
  one_time_day: false
};

export const formErrorInitialState = {
  exec_secondsError: false,
  exec_timeError: false,
  nameError: false,
  last_exec_timeError: false,
  descriptionError: false,
  loginError: false,
  passwordError: false,
  ipv4_addressError: false,
  portError: false
};

export const schema = Yup.object().shape({
  name: Yup.string().required(),
  description: Yup.string(),
  login: Yup.string(),
  password: Yup.string(),
  ipv4_address: Yup.string(),
  port: Yup.string()
});

export const timeMask = [
  /[0-9]/,
  /[0-9]/,
  ':',
  /[0-9]/,
  /[0-9]/,
  ':',
  /[0-9]/,
  /[0-9]/
];

export const dateTimeMask = [
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
  ' ',
  /[0-9]/,
  /[0-9]/,
  ':',
  /[0-9]/,
  /[0-9]/,
  ':',
  /[0-9]/,
  /[0-9]/
];
